import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Button,
  useToast,
  Select,
} from '@chakra-ui/react';
import useSWR from 'swr';
import { useSWRConfig } from 'swr';
import { Link } from 'react-router-dom';
import xhr from 'xhr';
import getWelcomelist from 'api/administrador/getWelcomeList';
import Loading from 'components/loading/Loading';
import SchoolBadge from 'components/SchoolBadge';
import dayjs from 'dayjs';

export default function BienvenidasAdmin() {
  const [checking, setChecking] = React.useState('');
  const [programTypeFilter, setProgramTypeFilter] = React.useState('');
  const { mutate: mutateGlobal } = useSWRConfig();
  const toast = useToast();

  const { data: welcomeList, mutate } = useSWR('getWelcomeList', getWelcomelist, {
    revalidateOnFocus: false,
  });

  const programTypeLabels = {
    grade: 'Bachillerato',
    'technical-career': 'Carrera técnica',
    course: 'Curso',
  };

  const handleStudentCheck = async (item) => {
    try {
      setChecking(item.student.id);

      await xhr.put(`/students/${item.student.id}`, {
        data: {
          welcome: true,
        },
      });

      mutate(
        welcomeList.filter((el) => el.student.id !== item.student.id),
        { revalidate: false }
      );

      mutateGlobal('statsAdmin');

      toast({
        title: '¡La actualización se realizó correctamente!',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Ocurrió un error al actualizar.',
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setChecking('');
    }
  };

  if (!welcomeList) return <Loading />;

  const programTypes = [
    ...new Set(welcomeList.map((item) => item.program?.type).filter(Boolean)),
  ];

  const filteredWelcomeList = programTypeFilter
    ? welcomeList.filter((item) => item.program?.type === programTypeFilter)
    : welcomeList;

  return (
    <>
      <Box fontSize="29px" fontWeight="bold">
        Bienvenidas a estudiantes nuevos
      </Box>

      <Box mt="15px" mb="15px" maxW="320px">
        <Select
          placeholder="Todos los tipos de programa"
          value={programTypeFilter}
          onChange={(e) => setProgramTypeFilter(e.target.value)}
        >
          {programTypes.map((type) => (
            <option key={type} value={type}>
              {programTypeLabels[type] || type}
            </option>
          ))}
        </Select>
      </Box>

      <Box mt="15px">
        <Box>
          <TableContainer>
            <Table marginY="sm">
              <Thead bg="gray.200">
                <Tr>
                  <Th>ID</Th>
                  <Th>Nombre</Th>
                  <Th>Teléfono</Th>
                  <Th>Programa</Th>
                  <Th>Tipo</Th>
                  <Th>Fecha</Th>
                  <Th>Perfil</Th>
                  <Th></Th>
                </Tr>
              </Thead>

              <Tbody>
                {filteredWelcomeList.map((item) => {
                  return (
                    <Tr key={item.enrollment.id}>
                      <Td>{item.student.id}</Td>

                      <Td>
                        <Box whiteSpace="break-spaces" width="180px">
                          {`${item.student.user.first_name} ${item.student.user.last_name}`}
                          <SchoolBadge student={item.student} />
                        </Box>
                      </Td>

                      <Td>{item.student.user.cellphone}</Td>

                      <Td>
                        <Box whiteSpace="break-spaces" width="180px">
                          {item.program.name}
                        </Box>
                      </Td>

                      <Td>{programTypeLabels[item.program?.type] || item.program?.type}</Td>

                      <Td>{dayjs(item.enrollment.createdAt).format('YYYY-MM-DD')}</Td>

                      <Td>
                        <Link
                          style={{ color: 'blue' }}
                          to={`/plataforma/administrador/ver-estudiante/${item.student.id}`}
                        >
                          Ver
                        </Link>
                      </Td>

                      <Td>
                        <Button
                          onClick={() => handleStudentCheck(item)}
                          isLoading={checking === item.student.id}
                        >
                          Verificar
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
}